















import { Component, Vue, Watch } from "vue-property-decorator"
import Button from "@/components/inputs/Button.vue"
import { TemplateSubmission } from "@/model/interfaces/submission/templateSubmission/templateSubmission"
import TemplateSubmissionModule from "@/store/modules/submission/TemplateSubmissionModule"
import TemplateSubmissionService from "@/services/submission/templateSubmission/TemplateSubmissionService"
import TextHeader from "@/components/elements/text/TextHeader.vue"
import { TranslateResult } from "vue-i18n"

@Component({
  components: {
    Button,
    TextHeader
  }
})
export default class TemplateViewPdf extends Vue {
  get submission(): TemplateSubmission | null {
    return TemplateSubmissionModule.currentSubmission
  }

  get pdfContent(): string | null {
    return TemplateSubmissionModule.currentSubmissionAsPDFContent
  }

  @Watch("submission", { immediate: true })
  async retrievePDFContent(): Promise<void> {
    if (this.submission) {
      await TemplateSubmissionModule.retrievePDFContent()
    }
  }

  async generatePDFExport(): Promise<void> {
    if (this.pdfContent) {
      window.open(this.pdfContent, "_blank")
    }
  }

  public t(tKey: string): TranslateResult {
    return this.$t("templatesubmission.templateview." + tKey)
  }
}
